import React, { HTMLAttributes } from 'react';
import { Skeleton } from '@sato/components';
import { twMerge } from 'tailwind-merge';

// TODO: Copied from sato-fi. Could be made into a shared component?
/** Placeholder loading animation for an (apartment) product card */
export const ApartmentCardSkeleton = (
  props: HTMLAttributes<HTMLDivElement>
) => (
  <div {...props} className={twMerge('w-full pb-3', props.className)}>
    <Skeleton className="aspect-video h-auto rounded-sm" />

    <div className="mt-3 flex px-3">
      <div className="flex-1">
        <Skeleton className="h-4 w-[70%] rounded-xs" />

        <Skeleton className="mt-2 h-3 w-[90%] rounded-xs" />

        <Skeleton className="mt-1 h-3 w-[75%] rounded-xs" />

        <Skeleton className="mt-3 h-3 w-10 rounded-xs" />
      </div>

      <div className="flex flex-col items-end">
        <Skeleton className="mt-auto h-3 w-8 rounded-xs" />
      </div>
    </div>
  </div>
);
